module.exports = __webpack_public_path__ + "img/otp-code.ef120c51.png";